import { Link } from "react-router-dom";
import { articles, categories, hotTags, testimonials, siteInfo } from "@/mocks/articles";
import SEOHead from "@/components/feature/SEOHead";

export default function HomePage() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 3);
  const latestArticles = articles.filter((a) => a.isNew).slice(0, 4);
  const regularArticles = articles.filter((a) => !a.isHot && !a.isNew).slice(0, 3);

  return (
    <>
      <SEOHead />
      {/* Organization + WebSite JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "吃瓜黑料在线",
            url: "https://www.chiguaheiliaozx.com",
            description: "吃瓜黑料在线首页聚合站，实时更新51吃瓜在线观看、黑料在线、网红塌房现场、明星黑料爆料等内容。",
            email: "tips@chiguaheiliaozx.com",
            foundingDate: "2024",
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "吃瓜黑料在线",
            url: "https://www.chiguaheiliaozx.com",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://www.chiguaheiliaozx.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "吃瓜黑料在线 - 首页",
            url: "https://www.chiguaheiliaozx.com",
            description: "吃瓜黑料在线首页聚合站，实时更新51吃瓜在线观看、黑料在线、网红塌房现场、明星黑料爆料等内容。",
            isPartOf: { "@type": "WebSite", name: "吃瓜黑料在线", url: "https://www.chiguaheiliaozx.com" },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: siteFaqs.map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: { "@type": "Answer", text: faq.answer },
            })),
          }),
        }}
      />
      {/* Hero Section */}
      <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20urban%20night%20scene%20with%20neon%20red%20and%20gold%20accents%2C%20abstract%20dramatic%20atmosphere%2C%20cinematic%20lighting%2C%20mysterious%20city%20vibe%2C%20dark%20alley%20with%20warm%20glowing%20signs%2C%20high%20contrast%20shadows%2C%20film%20noir%20aesthetic%2C%20artistic%20composition%2C%20gritty%20texture%2C%20dramatic%20ambient%20light&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="吃瓜黑料在线 - 网红塌房现场黑料实时更新"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-background-950"></div>

        <div className="absolute inset-0 flex items-center">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-2xl animate-fade-in-up">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-500/20 border border-primary-500/30 rounded-full mb-6">
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-fire-fill text-primary-500 text-xs"></i>
                </div>
                <span className="text-xs font-medium text-primary-400 whitespace-nowrap">
                  实时更新中 · 今日已更新 {articles.length} 条爆料
                </span>
              </div>

              <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-50 leading-tight mb-4">
                网红塌房现场
                <br />
                <span className="text-primary-500">黑料实时更新</span>
              </h1>
              <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-8 max-w-lg">
                吃瓜黑料在线首页聚合站，实时更新51吃瓜在线观看、黑料在线、网红塌房现场、明星黑料爆料等内容。每日不间断追踪网络热点事件，做最快的吃瓜第一站。
              </p>

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                <Link
                  to="/category/wanghong-tafang"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-foreground-50 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  立即吃瓜
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </Link>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-1.5 text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-information-line"></i>
                  </div>
                  了解更多
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hot Topics - Feature Grid */}
      <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-2">
            热门头条
          </h2>
          <p className="text-sm text-foreground-500">
            当前最火爆的吃瓜现场，热度爆表
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {hotArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className={`group relative overflow-hidden rounded-lg ${
                index === 0 ? "md:col-span-1 md:row-span-2" : ""
              } h-[280px] md:h-[320px] ${index === 0 ? "md:h-full" : ""} cursor-pointer`}
            >
              <img
                src={article.imageUrl}
                alt={article.title}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 bg-primary-500 text-foreground-50 text-xs rounded-full font-medium mb-2 whitespace-nowrap">
                  {article.category}
                </span>
                <h3 className="text-base md:text-lg font-bold text-foreground-50 leading-snug mb-1.5 group-hover:text-primary-300 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-300 line-clamp-2 mb-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-eye-line"></i>
                    </div>
                    {article.views >= 10000
                      ? `${(article.views / 10000).toFixed(0)}万`
                      : article.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-message-2-line"></i>
                    </div>
                    {article.comments}
                  </span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Real-time Updates - Grid */}
      <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-8 gap-3">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-2">
              实时更新
            </h2>
            <p className="text-sm text-foreground-500">
              最新爆料，最快吃瓜，不错过任何大瓜
            </p>
          </div>
          <Link
            to="/category/zhibo-fanche"
            className="text-sm text-primary-400 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap flex items-center gap-1"
          >
            查看全部
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {latestArticles.length > 0 && (
            <div className="lg:col-span-1">
              <Link
                to={`/article/${latestArticles[0].slug}`}
                className="group block bg-background-900 rounded-lg overflow-hidden h-full cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={latestArticles[0].imageUrl}
                    alt={latestArticles[0].title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-0.5 bg-primary-500 text-foreground-50 text-xs rounded-full font-medium whitespace-nowrap">
                      最新爆料
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-base font-bold text-foreground-50 mb-2 group-hover:text-primary-400 transition-colors duration-200">
                    {latestArticles[0].title}
                  </h3>
                  <p className="text-xs text-foreground-400 line-clamp-2 mb-3">
                    {latestArticles[0].excerpt}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-600">
                    <span>{latestArticles[0].date}</span>
                    <span>{latestArticles[0].comments} 评论</span>
                  </div>
                </div>
              </Link>
            </div>
          )}

          <div className="lg:col-span-2 flex flex-col gap-4">
            {latestArticles.slice(1).map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group flex gap-4 p-4 bg-background-900 hover:bg-background-800 rounded-lg transition-colors duration-200 cursor-pointer"
              >
                <div className="relative w-24 h-24 md:w-28 md:h-28 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-2 left-2">
                    <span className="px-1.5 py-0.5 bg-secondary-500 text-foreground-50 text-[10px] rounded font-medium whitespace-nowrap">
                      {article.category}
                    </span>
                  </div>
                </div>
                <div className="flex-1 min-w-0 flex flex-col justify-center">
                  <h3 className="text-sm md:text-base font-bold text-foreground-50 mb-1.5 group-hover:text-primary-400 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-1 mb-2">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-600">
                    <span>{article.date}</span>
                    <span className="flex items-center gap-1">
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-eye-line"></i>
                      </div>
                      {article.views >= 10000
                        ? `${(article.views / 10000).toFixed(0)}万`
                        : article.views}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Category Quick Nav */}
      <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-8">
          分类吃瓜
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 bg-background-900 hover:bg-background-800 border border-background-700 hover:border-primary-500/30 rounded-lg transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-primary-500/10 rounded-full group-hover:bg-primary-500/20 transition-colors duration-200">
                <i className={`${cat.icon} text-primary-500 text-lg`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-300 group-hover:text-foreground-50 transition-colors duration-200 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-600">
                {cat.count}条
              </span>
            </Link>
          ))}
        </div>
      </section>

      {/* Hot Tags Cloud */}
      <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10">
        <div className="bg-background-900/50 border border-background-700 rounded-lg p-6">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-hashtag text-primary-500"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-50">
              热门标签
            </h3>
          </div>
          <div className="flex flex-wrap gap-2">
            {hotTags.map((tag) => (
              <Link
                key={tag}
                to={`/category/wanghong-tafang`}
                className="px-3 py-1.5 bg-background-800 hover:bg-background-700 text-xs text-foreground-400 hover:text-primary-400 rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                #{tag}
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* More Articles - Feature Grid */}
      <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-8">
          更多爆料
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {regularArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-900 rounded-lg overflow-hidden cursor-pointer hover:bg-background-800 transition-colors duration-200"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 bg-secondary-500 text-foreground-50 text-xs rounded-full font-medium whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-50 mb-2 group-hover:text-primary-400 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-600">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-eye-line"></i>
                    </div>
                    {article.views >= 10000
                      ? `${(article.views / 10000).toFixed(0)}万`
                      : article.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Testimonials */}
      <section className="w-full bg-background-900/70 py-14 md:py-18">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="mb-10">
            <span className="inline-block px-3 py-1 bg-primary-500/10 border border-primary-500/20 text-primary-400 text-xs rounded-full font-medium mb-3 whitespace-nowrap">
              吃瓜群众说
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-2">
              吃瓜群众的真实评价
            </h2>
            <p className="text-sm text-foreground-500">
              看看广大吃瓜群众对我们平台的评价
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {testimonials.map((t) => (
              <div
                key={t.id}
                className="bg-background-950 border border-background-700 rounded-lg p-5 flex flex-col"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-50">
                      {t.name}
                    </div>
                    <div className="text-xs text-foreground-600">
                      {t.username}
                    </div>
                  </div>
                </div>
                <p className="text-xs text-foreground-400 leading-relaxed flex-1">
                  &ldquo;{t.comment}&rdquo;
                </p>
                <div className="flex items-center gap-0.5 mt-3">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <div key={star} className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500 text-xs"></i>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative w-full py-20 md:py-28 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20background%20with%20red%20and%20gold%20flowing%20gradients%2C%20cinematic%20atmosphere%2C%20luxurious%20dark%20texture%2C%20mysterious%20ambient%20light%2C%20elegant%20composition%2C%20high%20contrast%2C%20artistic%20noir%20aesthetic%2C%20deep%20shadows%20with%20warm%20highlights&width=1920&height=800&seq=cta-bg-home&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/40"></div>
        <div className="relative max-w-7xl mx-auto px-4 md:px-6">
          <div className="max-w-xl">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-50 mb-4">
              不想错过任何大瓜？
            </h2>
            <p className="text-sm text-foreground-300 leading-relaxed mb-8">
              下载吃瓜黑料在线APP，重大爆料第一时间推送。全网最快吃瓜速度，你值得拥有。
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <button className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-50 text-background-950 rounded-full text-sm font-semibold hover:bg-foreground-200 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-apple-fill"></i>
                </div>
                iOS 下载
              </button>
              <button className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-50/10 border border-foreground-50/30 text-foreground-50 rounded-full text-sm font-semibold hover:bg-foreground-50/20 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-android-line"></i>
                </div>
                Android 下载
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-18">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-8">
          常见问题
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {siteFaqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-900 border border-background-700 rounded-lg overflow-hidden"
            >
              <summary className="flex items-center justify-between p-4 cursor-pointer list-none">
                <h4 className="text-sm font-semibold text-foreground-50 pr-4">
                  {faq.question}
                </h4>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                  <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                </div>
              </summary>
              <div className="px-4 pb-4">
                <p className="text-xs text-foreground-400 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </section>
    </>
  );
}

const siteFaqs = [
  {
    question: "吃瓜黑料在线的爆料信息可信吗？",
    answer: "我们坚持「有实锤才发」的原则。每一条爆料都会经过多方交叉验证，标注信息来源和可信度等级。对于未经证实的传闻，我们会明确标注「待核实」标签，让用户理性判断。",
  },
  {
    question: "如何第一时间收到最新爆料推送？",
    answer: "您可以通过关注我们的官方社交媒体账号、下载官方APP（即将上线）或收藏本站并开启浏览器通知来获取最新爆料推送。我们承诺：重大爆料发生后5分钟内推送。",
  },
  {
    question: "被爆料的内容可以要求删除吗？",
    answer: "如果爆料内容存在事实错误，我们会在核实后立即更正或撤稿。但如果爆料内容属实且涉及公众利益，我们将依法保留报道权利。任何删稿请求请通过官方邮箱提交书面材料和证据。",
  },
  {
    question: "吃瓜黑料在线有APP吗？",
    answer: "我们的APP正在紧锣密鼓地开发中，预计将于近期上线各大应用商店。届时将提供更流畅的阅读体验、更及时的推送通知和独家爆料内容。敬请期待！",
  },
];